export default __webpack_public_path__ + "static/media/_Support.c20442de.svg";